import { render, staticRenderFns } from "./SsoCallback.vue?vue&type=template&id=1be98248&scoped=true"
import script from "./SsoCallback.vue?vue&type=script&lang=js"
export * from "./SsoCallback.vue?vue&type=script&lang=js"
import style0 from "./SsoCallback.vue?vue&type=style&index=0&id=1be98248&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1be98248",
  null
  
)

export default component.exports